<h2 class="mb-3 my-6 font-bold text-xl">نظرات کاربران {{HotelHeader?.FullName}} </h2>
<div class="w-full flex justify-between flex-col lg:flex-row" *ngIf="dataVotes?.length">
    <div class="flex items-end">
        <span class="text-blue-500 font-bold text-xl">{{dataSourceLabelHotelReview?.AvgRate}}</span>
        <span class="text-sm text-muted mb-1">/</span>
        <span class="text-sm text-muted mb-1">5</span>
        <div class="mr-3">
            <p class="text-sm"> {{dataSourceLabelHotelReview?.AvgRateTitle}}</p>
            <p class="text-sm text-muted">{{dataSourceLabelHotelReview?.TotalReview}} نظر</p>
        </div>
    </div>
    <div *ngIf="dataVotes?.length">
        <button mat-button color="primary" (click)="showModalComments()" class="icon-arrow-button flex items-center">
            <span class="text-blue-500 text-sm !font-medium">مشاهده {{dataSourceLabelHotelReview?.TotalReview}} نظر</span>
            <i class="ico-Left text-2xl"></i>
        </button>
    </div>
</div>
<div class="hidden lg:block" *ngIf="dataVotes?.length">

    <div class="w-full p-3 border-bottom" *ngFor="let item of dataVotes">

        <div class="w-full p-3">
            <div class="w-full mt-4">

                <p class="text-sm">
                    <span class="text-sm text-blue-500">{{item?.Rate?.replace('.0','')}}</span>
                    <span class="text-sm text-black-500 mr-2">{{item?.RateTitle}}</span>
                </p>
                <p class="text-sm text-muted"> {{item?.GuestName}}</p>

            </div>
            <div class="w-full mt-4">
                <h4 class="text-sm font-bold">{{item?.Title}}</h4>
                <p class="text-sm text-black-300 mt-3">
                    {{item?.Description}}
                </p>
                <p class="text-sm text-black-200 mt-3">
                    {{item?.AddDatePersian}}
                </p>
            </div>
            <!-- HotelAnswer -->
            <div class="w-full mt-4 bg-metal-50 p-3 rounded-lg" *ngIf="item.HotelAnswer">
                <h4 class="text-sm font-bold" *ngIf="accommodation() == 'ecolodge';else nameCommentHost">”پاسخ میزبان"</h4>
                <ng-template #nameCommentHost>
                    <h4 class="text-sm font-bold">”پاسخ هتل“</h4>
                </ng-template>
                <p class="text-sm text-black-300 mt-3">
                    {{item?.HotelAnswer}}
                </p>
                <p class="text-sm text-black-200 mt-3">
                    {{item?.AnswerDatePersian}}
                </p>
            </div>
        </div>

    </div>
</div>
<div class="block lg:hidden my-3" id="slider-comments" *ngIf="dataVotes?.length">
    <ng-container *ngIf="resetSwiper()">
    <swiper [config]="configSwiperComments">

        <ng-template swiperSlide *ngFor="let item of dataVotes">

            <div class="w-full p-3 border border-solid rounded-xl h-[200px]">
                <div class="w-full mt-4">

                    <p class="text-sm">
                        <span class="text-sm text-blue-500">{{item?.Rate?.replace('.0','')}}</span>
                        <span class="text-sm text-black-500 mr-2">{{item?.RateTitle}}</span>
                    </p>
                    <p class="text-sm text-muted"> {{item?.GuestName}}</p>

                </div>
                <div class="w-full mt-4">
                    <h4 class="text-sm font-bold">{{item?.Title}}</h4>
                    <p class="text-sm text-black-300  h-[60px] overflow-hidden">
                        {{item?.Description}}
                    </p>
                    <p class="text-sm text-black-200 mt-3">
                        {{item?.AddDatePersian}}
                    </p>
                </div>
            </div>

        </ng-template>
    </swiper>
</ng-container>
</div>
<div class="w-full text-center flex justify-center items-center flex-col" *ngIf="!dataVotes?.length">
    <img src="assets/images/no-comments.svg">
    <p class="text-black-400 my-3 text-base !font-normal">بدون نظر</p>
    <p class="text-sm text-black-500  mb-4 !font-medium">در صورتی که در این هتل اقامت داشته‌اید، می‌توانید نظر خود را ثبت کنید.</p>
    <a  class="!font-semi-bold px-16 flex justify-center items-center !border-solid !border !text-blue-500 rounded-lg !border-blue-500 !h-11" 
    href="https://www.iranhotelonline.com/persian/pursuit/tracking/" >ثبت نظر</a>
</div>